import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/Personalisation.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_2 = { class: "anchor-bottom" };
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useQuizApi } from '@/composables/useQuizApi';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PersonalisationLandingPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getQuestionnaireByKey } = useQuizApi();
        const about = ref(false);
        function onLoad() {
            getCustomer();
        }
        function startSurvey() {
            getQuestionnaireByKey('GOALS', (q) => {
                console.log(q, 'Found this questionnaire');
                router.push({ path: '/Questionnaire/' + q.id, query: { theme: 'dark', allowBack: 'false' } });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                (!about.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[3] || (_cache[3] = _createElementVNode("h1", null, "You're all set!", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("p", null, "Before we dive in, we'd like to understand your financial goals better.", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("img", {
                            class: "heroImg",
                            src: _imports_0
                        }, null, -1)),
                        _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                                _createVNode(_component_v_icon, { icon: "mdi-check" }),
                                _cache[0] || (_cache[0] = _createTextVNode(" Take control of your finances"))
                            ]),
                            _createElementVNode("p", null, [
                                _createVNode(_component_v_icon, { icon: "mdi-check" }),
                                _cache[1] || (_cache[1] = _createTextVNode(" Develop a more positive relationship with your money"))
                            ]),
                            _createElementVNode("p", null, [
                                _createVNode(_component_v_icon, { icon: "mdi-check" }),
                                _cache[2] || (_cache[2] = _createTextVNode(" Tailored insights and guidance"))
                            ])
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("p", null, null, -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(MGButton, {
                                alt: false,
                                text: "continue",
                                arrow: true,
                                onClick: startSurvey
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
